import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { courses, roles } from "../../../config";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import Select from "react-select";

const CreateResumeAccess = () => {
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    courseName:"",
    userBatchName:""
  });

  const [errors, setErrors] = useState<any>({});
  const [batchData, setBatchData] = useState<any>([]);


 

  const handleInput = (e:any) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors:any) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const bOptions = batchData?.map((type: any) => ({ value: type.batchName, label: type.batchName }));

  useEffect(() => {
    getMeets();
  }, []);

  const getMeets = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getAllBatch(data).then((res: any) => {
      if (res.status === "Success") {
        setBatchData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const validate = () => {
    const newErrors:any = {};


    if (!formData.courseName) {
      newErrors.courseName = "Course Name is required";
    }

    if (!formData.userBatchName) {
      newErrors.userBatchName = "Batch is required";
    } 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = (e:any) => {
    e.preventDefault();
    let userData = {
      courseName:formData.courseName,
      userBatchName:formData?.userBatchName || ''

  };
    if (validate()) {
      AdminService.createResume(userData).then((res) => {
        if (res.status === "Fail") {
          toast.error(res.error);
        } else {
          toast.success(res.message);
          navigate("/admin/resumeAccess");
        }
      });
    }
  };

  const handleCancel = () => {
    navigate("/admin/resumeAccess");
  };
  const handleSelectChange = (selectedOption: any, { name }: any) => {
    setFormData({ ...formData, [name]: selectedOption.value });
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: "",
    }));
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
      </div>
      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>
        <div className="col-md-10 content-scroll content-bg px-3 py-3">
          <h4 style={{ textAlign: "left" }}>
            <b>Create Resume Access</b>
          </h4>
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group mt-3">
                  <label className="register-font">Batch Name *</label>
                  <Select
                    options={bOptions}
                    name="userBatchName"
                    placeholder="Select Batch"
                    onChange={handleSelectChange}
                  />
                  {errors.userBatchName && (
                    <div className="text-danger">{errors.userBatchName}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
              <div className="form-group mt-3">
                  <label className="register-font">Domain Of Interest *</label>
                  <select
                    className={`form-control mt-2 ${
                      errors.courseName ? "is-invalid" : ""
                    }`}
                    onChange={handleInput}
                    name="courseName"
                  >
                    <option>Select of Course</option>
                    {courses.map((ele: any, index) => {
                      return (
                        <option value={ele.name} key={index}>
                          {ele.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.courseName && (
                    <div className="invalid-feedback">{errors.courseName}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-3">
              <button
                type="submit"
                className="btn btn-primary me-2"
                onClick={handleUpdate}
              >
                Submit
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateResumeAccess;
